import { Loading } from "components/Loading";
import { AuthContext } from "contexts/authContext";
import { ReactNode, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { setAuthorization } from "services/axios/api";

interface RequiredAuthProps {
	children: ReactNode;
}

export function RequiredAuth({ children }: RequiredAuthProps) {
	const [isLoading, setIsLoading] = useState(true);
	const navigate = useNavigate();
	const { getToken } = useContext(AuthContext);

	async function awaitToken() {
		setIsLoading(true);
		const token = await getToken();

		setAuthorization(token ?? "");

		if (!token) {
			navigate("/login");
			setIsLoading(false);
		}
		setIsLoading(false);
	}

	useEffect(() => {
		awaitToken();
	}, []);

	return <>{isLoading ? <Loading /> : children}</>;
}
